/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { EmptyResponse } from '../../models/empty-response';

export interface IdentityControllerRevokeDevice$Params {
  id: number;
  device_id: number;
}

export function identityControllerRevokeDevice(http: HttpClient, rootUrl: string, params: IdentityControllerRevokeDevice$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: EmptyResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, identityControllerRevokeDevice.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('device_id', params.device_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: EmptyResponse;
      }>;
    })
  );
}

identityControllerRevokeDevice.PATH = '/identity/{id}/devices/{device_id}';
